<template>
	<div>
		<header class="page-title">
			<h2>Provider Types</h2>
			<div class="ml-auto">
				<a @click="openModal" href="#" class="btn btn-md btn-success"><i class="fas fa-plus" v-show="userRoles.includes('provider_types.create')"></i> New Provider Type</a>
			</div>
		</header>

		<provider-type-list-filter
				:data-endpoint="endPoint"
				:data-url-params="urlParams"
		></provider-type-list-filter>

		<provider-type-list
				:data-provider-type-list="providerTypeList"
		></provider-type-list>

		<modal @close="closeModal" v-show="isModalVisible">
			<template slot="header">
				<h4 class="modal-title">New Provider Type</h4>
			</template>
			<template slot="body">
				<div class="card">
					<header class="card-header language-list">
						<lang-selector></lang-selector>
					</header>
					<div class="card-body">
						<div class="form-group">
							<label for="name">Name</label>
							<input id="name" type="text" v-model="newProviderTypeData[clickedLang].name">
							<p class="input-error" v-if="errors.errors[errorNameCurrentLanguage]">{{ errors.errors[errorNameCurrentLanguage] }}</p>
						</div>
					</div>
				</div>
				<div class="form-group">
					<label for="slug">URL Slug (plural)</label>
					<input id="slug" type="text" v-model="newProviderTypeData.slug">
					<p class="input-error" v-if="errors.errors['slug']">{{ errors.errors['slug'] }}</p>
				</div>
			</template>
			<template slot="footer">
				<a @click="closeModal" aria-label="Close modal" class="btn btn-md btn-primary modal-close" href="#"><i class="fas fa-times"></i> Cancel</a>
				<a @click="createProviderType" class="btn btn-md btn-success" href="#"><i class="fas fa-plus"></i> Add Provider Type</a>
			</template>
		</modal>
	</div>
</template>

<script>
	import modal from "../../Modal/DefaultModal.vue";
	import Errors from '../../../Utils/Errors.js';
	import {eventBus} from '../../../app';

	export default {
		components: {
			modal
		},
		props: {
			dataProviderTypeList: {
				type: Array
			},
			dataEndpoint: {
				type: String
			},
			dataUrlParams: {
				type: Object,
				required: false
			},
		},
		data() {
			return {
				providerTypeList: this.dataProviderTypeList,
				endPoint: this.dataEndpoint,
				urlParams: this.dataUrlParams || [],
				isModalVisible: false,

				newProviderTypeData: {
					slug: null
				},
				errors: new Errors(),
				userRoles: this.$currentUserRoles,
				clickedLang: this.$defaultLanguage.locale,
			}
		},
		created() {
			let vm = this;

			// When setActiveStatus method ran, change selected data in form fields
			/* From LangSelector */
			eventBus.$on('setActiveStatus', function (clickedLang) {
				vm.clickedLang = clickedLang;
			});

			for (let i = 0; i < vm.$availableLanguages.length; i++) {
				vm.newProviderTypeData[vm.$availableLanguages[i].locale] = {
					name: ''
				}
			}
		},
		methods: {
			openModal: function () {
				let vm = this;
				vm.isModalVisible = true;

				for (let i = 0; i < vm.$availableLanguages.length; i++) {
					vm.newProviderTypeData[vm.$availableLanguages[i].locale] = {
						name: ''
					}
				}
			},
			closeModal: function () {
				this.isModalVisible = false;
			},
			createProviderType: function () {
				let vm = this;

				for (let i = 0; i < vm.$availableLanguages.length; i++) {
					if (vm.newProviderTypeData[vm.$availableLanguages[i].locale].name === '') {
						vm.newProviderTypeData[vm.$availableLanguages[i].locale] = null;
					}
				}
				axios.post('/api/' + vm.$selectedSite.slug + '/provider-types', vm.newProviderTypeData)
					.then(response => {
						if (response.data.success) {
							this.$toastr.success('New provider type saved.');
							vm.closeModal();
							setTimeout(function () {
								window.location.reload();
							}, 1000);
						} else {
							vm.errors.record(response.data);
							this.$toastr.error('Save new provider type failed.', 'Error');
						}
					})
					.catch(e => {
						vm.errors.record(e.response.data);
						this.$toastr.error('Save new provider type failed.', 'Error');
					});
			}
		},
		computed: {
			errorNameCurrentLanguage: function () {
				return this.clickedLang + '_name';
			}
		}
	}
</script>

<style scoped>

</style>
